import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { PortService } from "src/app/Services/PortService/port.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Patterns } from "../../Patterns/patterns";

@Component({
  selector: "app-select-port-for-order",
  templateUrl: "./select-port-for-order.component.html",
  styleUrls: ["./select-port-for-order.component.scss"],
})
export class SelectPortForOrderComponent implements OnInit {
  ports!: any[];
  selectedPortForm!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<SelectPortForOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public portService: PortService,
    public formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.selectedPortForm = this.formBuilder.group({
      countryId: [null, [Validators.required]],
      portId: [null, [Validators.required]],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getPort(event: MatSelectChange): void {
    this.portService.countryId = event.value;
    this.portService
      .getPortForMariHub(this.portService.countryId)
      .subscribe((res) => {
        this.ports = res as any;
      });
  }

  onSubmit(): void {
    if (!this.selectedPortForm.valid) {
      return;
    }
    this.dialogRef.close(this.selectedPortForm.value);
  }
}
